import React from "react";
import Css from "./Allproducts.module.css";
import { Link } from "react-router-dom";
import FrameWorkImage from "../PackageImage/FrameWorkImage.jsx";
import NativeImage from "../PackageImage/NativeImage.jsx";
const Allproducts = () => {
  const products = [
    {
      id: 66,
      title: "Instagram",
      FrameWork: "React & Node Js",
      paragraph: "Simple idea project but contains a lot of information like connecting with API & The Project",
      span: "Responsive",
      Preview: "https://chat97.netlify.app/",
      GitHub: "https://github.com/Mohamed-Adel0/Instagram",
      image: FrameWorkImage.instagram,
    },
    {
      id: 12,
      title: "Bistro-Bliss",
      FrameWork: "React & Node Js",
      paragraph: "1st Project using FullStack",
      span: "Responsive",
      Preview: "https://bistro-bliss97.netlify.app/",
      GitHub: "https://github.com/Mohamed-Adel0/BistroBliss-FullStack",
      image: FrameWorkImage.BistroBliss,
    },
    {
      id: 1,
      title: "Website ShopClothes",
      FrameWork: "React",
      paragraph: "4th Project talking about shopping Household & This Website",
      span: "Responsive",
      Preview: "https://shopclothes1.netlify.app/",
      GitHub: "https://github.com/Mohamed-Adel0/ShopClothes",
      image: FrameWorkImage.ShopClothes,
    },
    {
      id: 2,
      title: "Website ShopWise",
      FrameWork: "React",
      paragraph: "3rd Project talking about shopping Household & This Website",
      span: "Responsive 80%",
      Preview: "https://shopwise97.netlify.app/",
      GitHub: "https://github.com/Mohamed-Adel0/Shopwise",
      image: FrameWorkImage.ShopWise,
    },
    {
      id: 3,
      title: "Website ShowRoom",
      FrameWork: "React",
      paragraph: "5th Project talking about Show Room & This Website",
      span: "Responsive 90%",
      Preview: "https://showroom97.netlify.app/",
      GitHub: "https://github.com/Mohamed-Adel0/Show-Room",
      image: FrameWorkImage.ShowRoom,
    },
    {
      id: 4,
      title: "Website ShopRoom",
      FrameWork: "JavaScript",
      paragraph:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolores dignissimos est dolor beatae qui cupiditate.",
      span: "Responsive 80%",
      Preview: "https://mohamed-adel0.github.io/ShopRoom/",
      GitHub: "https://github.com/Mohamed-Adel0/ShopRoom",
      image: NativeImage.ShopRoom,
    },
    {
      id: 5,
      title: "Website CellOn",
      FrameWork: "JavaScript",
      paragraph: "Simple project By using Native",
      span: "Responsive",
      Preview: "https://mohamed-adel0.github.io/CellOn/",
      GitHub: "https://github.com/Mohamed-Adel0/CellOn",
      image: NativeImage.CellOn,
    },

    {
      id: 6,
      title: "Website Anime",
      FrameWork: "React",
      paragraph: "2nd Project using React for training & This Website",
      span: "Responsive 80%",
      Preview: "https://anime97.netlify.app/",
      GitHub: "https://github.com/Mohamed-Adel0/Anime",
      image: FrameWorkImage.Anime,
    },

    {
      id: 7,
      title: "Website Coffe",
      FrameWork: "React",
      paragraph: "1st Project using React for training & This Website",
      span: "Not Responsive",
      Preview: "https://coffe97.netlify.app/",
      GitHub: "https://github.com/Mohamed-Adel0/Caffe",
      image: FrameWorkImage.Coffe,
    },

    {
      id: 8,
      title: "Website Pharahos",
      FrameWork: "HTML & CSS",
      paragraph:
        "Our goal is to encourage more people around the world to visitEgypt by showing them the ancient parts in the form of photos ",
      span: "Not Responsive",
      Preview: "https://mohamed-adel0.github.io/Pharaohs/",
      GitHub: "https://github.com/Mohamed-Adel0/Pharaohs",
      image: NativeImage.Pharahos,
    },
    {
      id: 10,
      title: "Website JFC",
      FrameWork: "HTML & CSS",
      paragraph:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolores dignissimos est dolor beatae qui cupiditate.",
      span: "Responsive 70%",
      Preview: "https://mohamed-adel0.github.io/JFC/",
      GitHub: "https://github.com/Mohamed-Adel0/JFC",
      image: NativeImage.JFC,
    },
    {
      id: 11,
      title: "Website Shopping",
      FrameWork: "JavaScript",
      paragraph:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolores dignissimos est dolor beatae qui cupiditate.",
      span: "Not Responsive",
      Preview: "https://mohamed-adel0.github.io/Shopping/",
      GitHub: "https://github.com/Mohamed-Adel0/Shopping",
      image: NativeImage.Shopping,
    },
  ];
  return (
    <div>
      <div className={Css.container}>
        {products?.map((r) => (
          <div className={Css.cards} key={r.id}>
            <div className={Css.card}>
              <div className={Css.img}>
                <Link to={r.Preview} target="_blank">
                  <img src={r.image} alt="" />
                </Link>
              </div>
              <div className={Css.text}>
                <h2>
                  {r.title} <span>{r.FrameWork}</span>
                </h2>
                <p>
                  {r.paragraph} <span>{r.span}</span>
                </p>
                <div className={Css.src}>
                  <Link target="_blank" to={r.Preview}>
                    Preview
                  </Link>
                  <Link target="_blank" to={r.GitHub}>
                    GitHub
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Allproducts;
